// The portal's calls to /api/api-keys (features/api-access): shapes from packages/contracts.
// The SPA manages keys with the session cookie; it never uses one (guide → Stack).
import {
  ApiKeyResponse,
  IssuedApiKeyResponse,
  ListApiKeysResponse,
  WhitelistResponse,
  type IssueApiKeyRequest,
} from "@kilat/contracts/api-keys";
import { api } from "@/lib/api-client";

export const listApiKeys = () => api.request("/api/api-keys", { schema: ListApiKeysResponse });

export const issueApiKey = (input: IssueApiKeyRequest) =>
  api.request("/api/api-keys", { method: "POST", body: input, schema: IssuedApiKeyResponse });

export const rotateApiKey = (keyId: string) =>
  api.request(`/api/api-keys/${keyId}/rotate`, { method: "POST", schema: IssuedApiKeyResponse });

export const revokeApiKey = (keyId: string) =>
  api.request(`/api/api-keys/${keyId}/revoke`, { method: "POST", schema: ApiKeyResponse });

export const getWhitelist = (keyId: string) =>
  api.request(`/api/api-keys/${keyId}/whitelist`, { schema: WhitelistResponse });

/** The API replaces a whitelist whole; adding and removing one entry both send the new list. */
export const replaceWhitelist = (keyId: string, entries: readonly string[]) =>
  api.request(`/api/api-keys/${keyId}/whitelist`, { method: "PUT", body: { entries }, schema: WhitelistResponse });
